import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { SignalButton } from '@vallift/ngl';

@Component({
  selector: 'app-home-header-section',
  imports: [RouterLink, SignalButton],
  templateUrl: './home-header-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HomeHeaderSectionComponent {
  private readonly router = inject(Router);

  navigateToMyForms(): void {
    void this.router.navigate(['/my-forms']);
  }

  navigateToLogin(): void {
    void this.router.navigate(['/login']);
  }

  navigateToSignup(): void {
    this.router.navigate(['/signup'], {
      queryParams: {
        planKey: 'free',
      },
    });
  }
}
